document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".site-header");
  if (!header) return;

  // Dropdown nav items (Product / Company)
  header.querySelectorAll("[data-nav-dropdown]").forEach((item) => {
    const trigger = item.querySelector(".cfs-navitem__link--trigger");
    if (!trigger) return;
    trigger.addEventListener("click", () => {
      const willOpen = !item.classList.contains("is-open");
      header.querySelectorAll("[data-nav-dropdown]").forEach((el) => el.classList.remove("is-open"));
      if (willOpen) item.classList.add("is-open");
    });
  });

  document.addEventListener("click", (e) => {
    if (!header.contains(e.target)) {
      header.querySelectorAll("[data-nav-dropdown]").forEach((el) => el.classList.remove("is-open"));
    }
  });

  // Mobile menu toggle + drawer
  const toggle = header.querySelector(".mobile-action");
  const drawer = header.querySelector(".cfs-nav__drawer");
  if (toggle && drawer) {
    const closeDrawer = () => {
      toggle.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      drawer.classList.remove("is-open");
      document.body.classList.remove("cfs-nav-open");
    };

    toggle.addEventListener("click", () => {
      const willOpen = !drawer.classList.contains("is-open");
      toggle.classList.toggle("is-open", willOpen);
      toggle.setAttribute("aria-expanded", String(willOpen));
      drawer.classList.toggle("is-open", willOpen);
      document.body.classList.toggle("cfs-nav-open", willOpen);
    });

    drawer.querySelectorAll("a").forEach((a) => a.addEventListener("click", closeDrawer));
  }
});
